import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { Feedback, FeedbackListItem, FeedbacksStateType } from '../types/types';
import {
  getAllFeedbacks, getFeedbackById, createFeedback, updateFeedback,
  deleteFeedback,
} from '../actions/actions';

const initialState: FeedbacksStateType = {
  feedbackDetail: {
    isLoading: false,
    data: null,
  },
  feedbacks: [],
  isLoading: false,
};

const slice = createSlice({
  name: 'feedbacks',
  initialState,
  reducers: {
    dropDetailData(state: FeedbacksStateType) {
      state.feedbackDetail.data = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllFeedbacks.pending, (state: FeedbacksStateType) => {
      state.isLoading = true;
    });
    builder.addCase(getAllFeedbacks.fulfilled, (state: FeedbacksStateType, action: PayloadAction<FeedbackListItem[]>) => {
      state.feedbacks = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getAllFeedbacks.rejected, (state: FeedbacksStateType, action) => {
      logger.error('feedbacks/getAllFeedbacks', action.payload);
      state.isLoading = false;
    });

    builder.addCase(getFeedbackById.pending, (state: FeedbacksStateType) => {
      state.feedbackDetail.isLoading = true;
    });
    builder.addCase(getFeedbackById.fulfilled, (state: FeedbacksStateType, action: PayloadAction<Feedback>) => {
      state.feedbackDetail.data = action.payload;
      state.feedbackDetail.isLoading = false;
    });
    builder.addCase(getFeedbackById.rejected, (state: FeedbacksStateType, action) => {
      logger.error('feedbacks/getFeedbackById', action.payload);
      state.feedbackDetail.isLoading = false;
    });

    builder.addCase(createFeedback.pending, (state: FeedbacksStateType) => {
      state.feedbackDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(createFeedback.fulfilled, (state: FeedbacksStateType) => {
      state.feedbackDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(createFeedback.rejected, (state: FeedbacksStateType, action) => {
      logger.error('feedbacks/createFeedback', action.payload);
      state.feedbackDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(updateFeedback.pending, (state: FeedbacksStateType) => {
      state.feedbackDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(updateFeedback.fulfilled, (state: FeedbacksStateType) => {
      state.feedbackDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(updateFeedback.rejected, (state: FeedbacksStateType, action) => {
      logger.error('feedbacks/updateFeedback', action.payload);
      state.feedbackDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(deleteFeedback.pending, (state: FeedbacksStateType) => {
      state.isLoading = true;
    });
    builder.addCase(deleteFeedback.fulfilled, (state: FeedbacksStateType) => {
      state.isLoading = false;
    });
    builder.addCase(deleteFeedback.rejected, (state: FeedbacksStateType, action) => {
      logger.error('feedbacks/deleteFeedback', action.payload);
      state.isLoading = false;
    });
  },
});

export const feedbackActions = slice.actions;
export default slice.reducer;
